/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StripeCustomersPortalResponse
 */
export interface StripeCustomersPortalResponse {
    /**
     * 
     * @type {string}
     * @memberof StripeCustomersPortalResponse
     */
    portalUrl: string;
}

/**
 * Check if a given object implements the StripeCustomersPortalResponse interface.
 */
export function instanceOfStripeCustomersPortalResponse(value: object): value is StripeCustomersPortalResponse {
    if (!('portalUrl' in value) || value['portalUrl'] === undefined) return false;
    return true;
}

export function StripeCustomersPortalResponseFromJSON(json: any): StripeCustomersPortalResponse {
    return StripeCustomersPortalResponseFromJSONTyped(json, false);
}

export function StripeCustomersPortalResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): StripeCustomersPortalResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'portalUrl': json['portalUrl'],
    };
}

export function StripeCustomersPortalResponseToJSON(json: any): StripeCustomersPortalResponse {
    return StripeCustomersPortalResponseToJSONTyped(json, false);
}

export function StripeCustomersPortalResponseToJSONTyped(value?: StripeCustomersPortalResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'portalUrl': value['portalUrl'],
    };
}

